;(function () {
  'use strict'

  angular
    .module('contrast.version')
    .controller('TeamServerVersionCtrl', [
      '$scope',
      'GlobalService',
      TeamServerVersionCtrl
    ])

  function TeamServerVersionCtrl($scope, GlobalService) {
    $scope.model = {}
    $scope.model.version = GlobalService.getVersion() || ''
    $scope.model.release_notes = GlobalService.getRelease() || ''

    $scope.$on('teamserverproperties.update', function () {
      $scope.model.version = GlobalService.getVersion()
      $scope.model.release_notes = GlobalService.getRelease()
    })
  }
})()
